import Box from 'components/shared/Box'
import Icon from 'components/shared/Icon'
import Link from 'components/shared/Link'
import Text from 'components/shared/Text'
import { formatPrice } from 'helpers/helpers'
import { FormattedMessage } from 'react-intl'
import { FamilyPackageBoxDivider, FamilyPackageInfoBox } from './styles'
import { useAppSelector } from 'store/hooks'
import { Fragment } from 'react'
import { useApp } from 'store/steps'
import DateTitle from 'components/shared/DateTitle'
import { ReservationRowProps } from 'components/shared/Reservation/types'

export const FamilyPackageRow = ({
    isDownloadingAttachementsDisabled = false,
}: ReservationRowProps) => {
    const { language } = useApp()
    const { ticketsBundles } = useAppSelector(({ selfcare }) => selfcare)

    const ticketsBundlesSorted = ticketsBundles?.slice()?.sort((dayA, dayB) => {
        const dateA = new Date(dayA.original.detail.date)
        const dateB = new Date(dayB.original.detail.date)

        return dateA.getTime() - dateB.getTime()
    })

    return (
        <FamilyPackageBoxDivider isFullWidth>
            <Box
                direction="row"
                align="center"
                justify="space-between"
                isFullWidth
            >
                <Text variant="heading3" color="secondary_700">
                    <FormattedMessage
                        id="selfcare.bundles.section_caption"
                        defaultMessage="Pakiety"
                    />
                </Text>
                {!isDownloadingAttachementsDisabled && (
                    <Link
                        variant="primary"
                        textVariant="bodySmallStrong"
                        icon={null}
                        path={`${process.env.REACT_APP_API_URL}api/${language}/selfcare/attachment/bundle`}
                        data-testid="selfcare-button-download-bundle"
                    >
                        <FormattedMessage
                            id="selfcare.download_tickets"
                            defaultMessage="Pobierz bilety"
                        />
                    </Link>
                )}
            </Box>
            <FamilyPackageInfoBox
                direction="row"
                gap={16}
                mt={[16, 24]}
                mb={[16, 24]}
                pt={16}
                pb={16}
                pl={16}
                pr={16}
                isFullWidth
            >
                <Icon variant="tooltip" color="info" />
                <Text variant="bodySmall" color="info">
                    <FormattedMessage
                        id="selfcare.family_package_description"
                        defaultMessage="Voucher w Pakiecie Family 2+2 nie podlega anulowaniu ani edycji. <span>Możesz wykorzystać go online lub na miejscu przez rok od daty zakupu. Voucher wysłaliśmy mailowo.</span>"
                        values={{
                            span: (chunks: string[]) => (
                                <>
                                    <br />
                                    {chunks}
                                </>
                            ),
                        }}
                    />
                </Text>
            </FamilyPackageInfoBox>
            {ticketsBundlesSorted?.map(
                (
                    {
                        original: { detail, name, descriptions, price },
                        changes,
                    },
                    index
                ) => {
                    const description = descriptions?.length
                        ? descriptions[0].description?.split('(').join('<br>(')
                        : ''

                    return (
                        <Fragment key={`${detail.boxId}-${index}`}>
                            <DateTitle
                                index={index + 1}
                                date={
                                    changes && changes.detail.date
                                        ? changes.detail.date
                                        : detail.date
                                }
                            />
                            <Box
                                direction="row"
                                justify="space-between"
                                isFullWidth
                                mb={[16, 24]}
                                mt={[16, 24]}
                            >
                                <Box>
                                    <Text
                                        variant="bodySmall"
                                        color="grayscale_900"
                                        mb={4}
                                    >
                                        {name}
                                    </Text>
                                    <Text
                                        key={`description-${index}`}
                                        variant="bodySmall"
                                        color="grayscale_700"
                                        dangerouslySetInnerHTML={{
                                            __html: description || '',
                                        }}
                                    />
                                </Box>
                                {!!price && (
                                    <Text
                                        hasNoWrap
                                        variant="bodySmallStrong"
                                        color="secondary_500"
                                    >
                                        {formatPrice(price, true)}
                                    </Text>
                                )}
                            </Box>
                        </Fragment>
                    )
                }
            )}
        </FamilyPackageBoxDivider>
    )
}
